module.exports = __webpack_public_path__ + "static/media/bg_viagem.17c1eda9.png";